var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "py-3 px-3 relative flex flex-col bg-pure-white",
      attrs: { id: "upcoming_to_do_" + _vm.instruction.id }
    },
    [
      _c("div", { staticClass: "flex flex-col gap-1" }, [
        _c("div", { staticClass: "flex items-center gap-2" }, [
          _c("input", {
            staticClass: "cursor-pointer",
            attrs: {
              type: "checkbox",
              name: "instruction_checkbox_" + _vm.instruction.id,
              id: "instruction_checkbox_" + _vm.instruction.id
            },
            domProps: { checked: _vm.instruction.is_checked },
            on: {
              change: function($event) {
                return _vm.onCheckInstruction($event.target.checked)
              }
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "flex cursor-pointer truncate",
              on: {
                click: function($event) {
                  _vm.panelOpened = true
                }
              }
            },
            [
              _c("BlTextSubtitle3", {
                staticClass: "underline truncate",
                attrs: { text: _vm.instruction.title }
              })
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "pl-4 flex flex-col gap-1" }, [
          _c("div", { staticClass: "flex" }, [
            _c(
              "div",
              { staticClass: "h-6.5 px-2 rounded-full bg-slate-200 truncate" },
              [
                _c("BlTextBody2", {
                  staticClass: "truncate",
                  attrs: { title: _vm.prospectName, text: _vm.prospectName }
                })
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "flex" }, [
            _c(
              "div",
              {
                staticClass: "h-6.5 px-2 rounded-full",
                class: [_vm.isDueDateLate ? "bg-orange-100" : "bg-lime-100"]
              },
              [
                _c("BlTextBody2", {
                  class: [
                    _vm.isDueDateLate ? "text-orange-700" : "text-lime-700"
                  ],
                  attrs: { text: "Due date: " }
                }),
                _vm._v(" "),
                !_vm.instruction.due_date
                  ? _c("BlTextSubtitle3", {
                      class: [
                        _vm.isDueDateLate ? "text-orange-700" : "text-lime-700"
                      ],
                      attrs: { text: "-", c: "" }
                    })
                  : _c("BlTextSubtitle3", {
                      class: [
                        _vm.isDueDateLate ? "text-orange-700" : "text-lime-700"
                      ],
                      attrs: {
                        text: _vm.displayDate(
                          _vm.instruction.due_date,
                          "DD MMM YYYY, HH:mm"
                        )
                      }
                    })
              ],
              1
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _vm.instruction.instructionable_id
        ? _c("ProspectPanel", {
            attrs: {
              open: _vm.panelOpened,
              id: _vm.instruction.instructionable_id
            },
            on: {
              "close-panel": function($event) {
                _vm.panelOpened = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1071d65a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1071d65a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/salesPipeline/UpcomingTodo.vue
// module id = null
// module chunks = 